import React from 'react';

const WorkPermitStep5SafetyChecks = ({ formData, handleArrayChange, safetyChecks }) => {
  const selected = JSON.parse(formData.safetyChecksJson || '[]');
  const selectedIds = selected.map((c) => c.checkId || c);

  const toggleCheck = (check) => {
    const exists = selectedIds.includes(check.checkId);
    if (exists) {
      handleArrayChange(
        'safetyChecksJson',
        selected.filter((c) => (c.checkId || c) !== check.checkId)
      );
    } else {
      handleArrayChange('safetyChecksJson', [...selected, { checkId: check.checkId, checkName: check.checkName, checkType: check.checkType }]);
    }
  };

  return (
    <div className="work-permit-step">
      <h3 className="form-section-title">5. Safety Checks</h3>
      <div className="array-field-container">
        {safetyChecks.length === 0 && <p>No safety checks configured.</p>}
        {safetyChecks.map((check) => (
          <label key={check.checkId} className="checkbox-row">
            <input
              type="checkbox"
              checked={selectedIds.includes(check.checkId)}
              onChange={() => toggleCheck(check)}
            />
            <div>
              <div>{check.checkName}</div>
              <small className="muted">{check.checkType}</small>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default WorkPermitStep5SafetyChecks;

